import { Plus, Trash2 } from "lucide-react";
import USDateInput from "../USDateInput";
import { Card, MoneyInput, fmtUSD } from "./PfsPrimitives";

export default function LiabilityScheduleCard({
  title,
  rows,
  total,
  testidPrefix,
  addLabel,
  emptyHint,
  showDescription,
  descriptionLabel,
  onAdd,
  onUpdate,
  onRemove,
}) {
  return (
    <Card
      title={title}
      total={total}
      totalTestId={`${testidPrefix}-subtotal`}
      right={
        <button
          onClick={onAdd}
          className="text-xs font-mono uppercase tracking-widest text-slate-700 hover:text-slate-900 inline-flex items-center gap-1"
          data-testid={`${testidPrefix}-add-btn`}
        >
          <Plus className="w-3.5 h-3.5" /> {addLabel}
        </button>
      }
    >
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid={`${testidPrefix}-table`}>
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-widest font-mono text-slate-500 border-b border-slate-200">
              <th className="py-2 pr-2">Lender</th>
              {showDescription && <th className="py-2 px-2">{descriptionLabel || "Description"}</th>}
              <th className="py-2 px-2 text-right w-40">Original</th>
              <th className="py-2 px-2 text-right w-40">Current balance</th>
              <th className="py-2 px-2 text-right w-36">Pmt/mo</th>
              <th className="py-2 px-2 w-32">Maturity</th>
              <th className="py-2 pl-2 w-8"></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td
                  colSpan={showDescription ? 7 : 6}
                  className="py-6 text-center text-slate-500 text-sm"
                >
                  {emptyHint}
                </td>
              </tr>
            )}
            {rows.map((r, idx) => (
              <tr
                key={idx}
                className="border-b border-slate-100"
                data-testid={`${testidPrefix}-row-${idx}`}
              >
                <td className="py-2 pr-2 align-top min-w-[140px]">
                  <input
                    className="input-clean w-full text-xs"
                    value={r.lender || ""}
                    onChange={(e) => onUpdate(idx, "lender", e.target.value)}
                    placeholder="Wells Fargo"
                    data-testid={`${testidPrefix}-${idx}-lender`}
                  />
                </td>
                {showDescription && (
                  <td className="py-2 px-2 align-top min-w-[160px]">
                    <input
                      className="input-clean w-full text-xs"
                      value={r.description || ""}
                      onChange={(e) => onUpdate(idx, "description", e.target.value)}
                      placeholder={descriptionLabel || "Description"}
                      data-testid={`${testidPrefix}-${idx}-description`}
                    />
                  </td>
                )}
                <td className="py-2 px-2 align-top">
                  <MoneyInput
                    value={r.original_amount}
                    onChange={(v) => onUpdate(idx, "original_amount", v)}
                    testid={`${testidPrefix}-${idx}-original`}
                  />
                </td>
                <td className="py-2 px-2 align-top">
                  <MoneyInput
                    value={r.current_balance}
                    onChange={(v) => onUpdate(idx, "current_balance", v)}
                    testid={`${testidPrefix}-${idx}-balance`}
                  />
                </td>
                <td className="py-2 px-2 align-top">
                  <MoneyInput
                    value={r.monthly_payment}
                    onChange={(v) => onUpdate(idx, "monthly_payment", v)}
                    testid={`${testidPrefix}-${idx}-payment`}
                  />
                </td>
                <td className="py-2 px-2 align-top">
                  <USDateInput
                    value={r.maturity_date || ""}
                    onChange={(v) => onUpdate(idx, "maturity_date", v)}
                    testid={`${testidPrefix}-${idx}-maturity`}
                  />
                </td>
                <td className="py-2 pl-2 align-top">
                  <button
                    onClick={() => onRemove(idx)}
                    className="text-slate-300 hover:text-red-600"
                    aria-label="Delete row"
                    data-testid={`${testidPrefix}-${idx}-delete`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          {rows.length > 0 && (
            <tfoot>
              <tr className="border-t-2 border-slate-300 font-semibold">
                <td
                  colSpan={showDescription ? 3 : 2}
                  className="py-2 pr-2 text-right text-slate-700"
                >
                  Current balance total
                </td>
                <td
                  className="py-2 px-2 text-right tabular-nums"
                  data-testid={`${testidPrefix}-total`}
                >
                  {fmtUSD(total)}
                </td>
                <td colSpan={3}></td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </Card>
  );
}
